import React from 'react';

const SegmentsFormModal = React.lazy(() => import('../components/FormModal'));
const segmentsModalRegistry = {
    crm_segmentsId: SegmentsFormModal
};
export default segmentsModalRegistry;
